import 'objectFitPolyfill/dist/objectFitPolyfill.basic.min'

import anime from 'animejs'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import classNames from 'classnames'
import { DetectUA } from 'detect-ua'
import React, { Component } from 'react'
import { css, Global } from '@emotion/core'

import Button from '../components/button'
import Player from '../components/player'
import { WHITE, FS_M, EXPO_EASE_OUT, FS_S, mq } from '../css/style'

import globalStyles from '../css/layout.css'
import normalizeStyles from '../css/normalize.css'
import spriteStyles from '../css/sprite.css'

import cover from '../images/cover.jpg'
import mask1 from '../images/mask1.png'
import mask2 from '../images/mask2.png'
import title1 from '../images/title-1.png'
import title2 from '../images/title-2.png'
import purple from '../images/brush-purple.png'
import purpleDeezer from '../images/brush-deezer.png'
import video from '../videos/deezer-background.mp4'
import scrollImg from '../images/scroll.svg'
import foreground from '../images/overlay.png'

// import play from '../images/play.png'
import close from '../images/close.png'
import titleSmall from '../images/title-small.png'
import Analytics from '../components/analytics'
import Sound from '../components/sound'
import Part2, { buttonClass } from '../components/part-2'

import titleMob1 from '../images/title-mob-1.png'
import titleMob2 from '../images/title-mob-2.png'
import Arrow from '../components/arrow'
import Header from '../components/header'
import Smooth from '../components/smooth'

try {
    require('intersection-observer')
} catch (e) {}

class Home extends Component {
    state = {
        isVideoVisible: false,
        isButtonVisible: false,
        isMaskComplete: false,
        player: null,
        isVideoPlaying: false,
        isPurpleVisible: false,
        isDateVisible: false,
        isCoverVisible: false,
        isCoverBlack: false,
        isCookieAccepted: true,
        isSoundOn: null,
        isPhoneWidth: false,
        isMixtapeInViewport: false,
        isDesktop: false,
    }

    maskRefs = Array(2)
        .fill(0)
        .map(() => React.createRef())
    subtitleRef = React.createRef()
    videoRef = React.createRef()
    purpleRef = React.createRef()
    bigDateRef = React.createRef()
    coverRef = React.createRef()

    componentDidMount() {
        window.objectFitPolyfill()

        window.addEventListener('resize', this.handleResize)
        this.handleResize()

        window.addEventListener('scroll', this.handleScroll)
        window.addEventListener('mousemove', this.handleWindowMouse)

        this.setState(
            {
                isCookieAccepted:
                    document.cookie.replace(
                        /(?:(?:^|.*;\s*)rgpd\s*=\s*([^;]*).*$)|^.*$/,
                        '$1'
                    ) === 'true',
                isDesktop: new DetectUA().isDesktop,
            },
            () => {
                const tl = anime.timeline()

                tl.add({
                    targets: [
                        this.maskRefs[0].current,
                        this.maskRefs[1].current,
                    ],
                    translateX: '100%',
                    duration: 1000,
                    delay: anime.stagger(200, { start: 500 }),
                    easing: 'cubicBezier(1, 0.2, 0, 0.8)',
                })

                tl.add(
                    {
                        targets: this.maskRefs[0].current,
                        duration: 100,
                        opacity: 0,
                    },
                    1500
                )

                tl.add(
                    {
                        targets: this.maskRefs[1].current,
                        duration: 100,
                        opacity: 0,
                    },
                    1700
                )

                tl.add(
                    {
                        duration: 0,
                        complete: () => {
                            this.setState({ isPurpleVisible: true })
                        },
                    },
                    '-=200'
                )

                tl.add(
                    {
                        duration: 0,
                        complete: () => {
                            this.setState({ isVideoVisible: true })
                            this.videoRef.current.play()
                        },
                    },
                    '+=300'
                )

                tl.add({
                    targets: Array.from(
                        this.subtitleRef.current.children
                    ).slice(0, this.subtitleRef.current.children.length - 2),
                    duration: 300,
                    delay: anime.stagger(100),
                    opacity: 1,
                    easing: 'easeOutQuint',
                    translateY: [-10, 0],
                })

                tl.add(
                    {
                        targets: Array.from(
                            this.subtitleRef.current.children
                        ).slice(this.subtitleRef.current.children.length - 2),
                        duration: 500,
                        opacity: 1,
                        easing: 'easeOutQuint',
                    },
                    '+=100'
                )

                tl.add(
                    {
                        duration: 0,
                        complete: () => {
                            this.setState({
                                isDateVisible: true,
                            })
                        },
                    },
                    '-=200'
                )

                tl.add(
                    {
                        targets: this.bigDateRef.current.children,
                        duration: 1000,
                        delay: anime.stagger(300),
                        opacity: 1,
                        easing: 'linear',
                    },
                    '-=400'
                )

                tl.add(
                    {
                        duration: 0,
                        complete: () => {
                            this.setState({
                                isButtonVisible: true,
                            })
                        },
                    },
                    '-=800'
                )

                tl.add(
                    {
                        duration: 0,
                        complete: () => {
                            this.setState({
                                isCoverVisible: true,
                            })

                            this.handleResize()
                        },
                    },
                    '-=400'
                )
            }
        )
    }

    handleScroll = () => {
        this.setState({
            isCoverVisible:
                window.scrollY === 0 ||
                (window.scrollY > window.innerHeight * 1.4 &&
                    window.scrollY < this.maxHeight - window.innerHeight * 1.5),
            isCoverBlack: window.scrollY > window.innerHeight * 1.4,
        })
    }

    handleResize = () => {
        this.setState({ isPhoneWidth: window.innerWidth < 576 })

        const body = document.body,
            html = document.documentElement

        this.maxHeight = Math.max(
            body.scrollHeight,
            body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
        )
    }

    handlePlayerPlay = () => {
        this.setState({ isVideoPlaying: true })
        this.state.player.seekTo(0)

        setTimeout(() => this.state.player.playVideo(), 800)
    }

    handlePlayerPause = () => {
        this.setState({ isVideoPlaying: false })
        setTimeout(() => this.state.player.pauseVideo(), 1000)
    }

    handlePlayerInit = player => {
        this.setState({ player })
    }

    handleCookieClick = () => {
        document.cookie = 'rgpd=true'
        this.setState({ isCookieAccepted: true })
    }

    handleSoundClick = () => {
        this.videoRef.current.muted = this.state.isSoundOn

        this.setState(state => {
            return { isSoundOn: state.isSoundOn === true ? false : true }
        })
    }

    handleMixtapeIn = () => {
        this.setState({ isMixtapeInViewport: true })
    }

    render() {
        const { playlistLink } = this.props.data.site.siteMetadata

        const scrollableDiv = (
            <>
                <Player
                    videoId="Fpmqc45XP1Q"
                    handlePlayerInit={this.handlePlayerInit}
                    isVideoPlaying={this.state.isVideoPlaying}
                    onEnd={this.handlePlayerPause}
                />
                <Button
                    isButtonVisible={this.state.isVideoPlaying}
                    svg={close}
                    customCss={stopBtnClass}
                    handleClick={this.handlePlayerPause}
                    text="Fermer"
                />
                <div
                    css={containerClass}
                    className={this.state.isVideoPlaying ? 'is-hidden' : ''}
                >
                    <div
                        css={foregroundClass}
                        className={
                            this.state.isPurpleVisible ? 'is-visible' : ''
                        }
                    />
                    <video
                        ref={this.videoRef}
                        src={video}
                        playsInline
                        muted
                        loop
                        css={videoClass}
                        data-object-fit="cover"
                        data-object-position="center center"
                        className={
                            this.state.isVideoVisible ? 'is-visible' : ''
                        }
                    />
                    <Header />
                    <div css={dateContainerClass}>
                        <time
                            css={bigDateClass}
                            dateTime="2019-04-16"
                            ref={this.bigDateRef}
                        >
                            <span>16.</span>
                            <span>04.</span>
                            <span>19</span>
                        </time>
                        <h1>
                            <div css={mainMaskClass}>
                                <div
                                    css={containerMaskClass}
                                    className="first"
                                    ref={this.maskRefs[0]}
                                >
                                    {!this.state.isVideoVisible && (
                                        <img src={mask1} alt="" />
                                    )}
                                    <div />
                                </div>
                                <img
                                    src={
                                        this.state.isPhoneWidth
                                            ? titleMob1
                                            : title1
                                    }
                                    alt="Le futur du rap est déjà sur Deezer"
                                    css={titleClass}
                                />
                            </div>
                            <div css={mainMaskClass}>
                                <div
                                    css={containerMaskClass}
                                    className="two"
                                    ref={this.maskRefs[1]}
                                >
                                    {!this.state.isVideoVisible && (
                                        <img src={mask2} alt="" />
                                    )}
                                    <div />
                                </div>
                                <div
                                    css={purpleClass}
                                    ref={this.purpleRef}
                                    className={
                                        this.state.isPurpleVisible
                                            ? 'is-visible'
                                            : ''
                                    }
                                >
                                    <img
                                        src={
                                            this.state.isPhoneWidth
                                                ? titleMob2
                                                : title2
                                        }
                                        alt="Le futur du rap est déjà sur Deezer"
                                        css={titleClass}
                                    />
                                </div>
                            </div>
                        </h1>
                        <p css={subtitleClass} ref={this.subtitleRef}>
                            <strong
                                className={
                                    this.state.isDateVisible ? 'is-visible' : ''
                                }
                            >
                                <span />
                                <img src={titleSmall} alt="" />
                            </strong>{' '}
                            <span>une</span> <span>mixtape</span>{' '}
                            <span>exclusive</span>
                        </p>
                    </div>
                    <div
                        css={playBtnClass}
                        className={
                            this.state.isButtonVisible ? 'is-visible' : ''
                        }
                    >
                        <a
                            href={playlistLink}
                            css={css`
                                ${buttonClass};

                                ${mq.small(css`
                                    margin-right: 3em;
                                `)};
                            `}
                        >
                            <div className="border" />
                            <Arrow fill="white" /> Écouter
                        </a>
                        <button
                            href={playlistLink}
                            onClick={this.handlePlayerPlay}
                            css={css`
                                ${buttonClass};
                            `}
                        >
                            <div className="border" />
                            <Arrow fill="white" speed={true} /> Voir la vidéo
                        </button>
                    </div>
                    <img src={scrollImg} alt="" css={scrollClass} />
                </div>
                {this.state.isDesktop && (
                    <Sound
                        isSoundOn={this.state.isSoundOn}
                        handleSoundClick={this.handleSoundClick}
                    />
                )}
                <Part2
                    handleMixtapeIn={this.handleMixtapeIn}
                    isMixtapeInViewport={this.state.isMixtapeInViewport}
                    playlistLink={playlistLink}
                    isDesktop={this.state.isDesktop}
                />
            </>
        )

        return (
            <>
                <Helmet>
                    <title>
                        Le Futur du Rap - La mixtape des nouveaux talents du rap
                        français, avec Deezer
                    </title>
                    <meta
                        name="description"
                        content="Découvrez la mixtape exclusive des nouveaux talents du rap, artistes émergents qui sont le futur du genre, avec Deezer. Retrouvez la vidéo officielle et la mixtape en exclusivité !"
                    />
                    <meta
                        property="og:title"
                        content="Le Futur du Rap - La mixtape des nouveaux talents du rap français, avec Deezer"
                    />
                    <meta
                        property="og:description"
                        content="Découvrez la mixtape exclusive des nouveaux talents du rap, artistes émergents qui sont le futur du genre, avec Deezer. Retrouvez la vidéo officielle et la mixtape en exclusivité !"
                    />
                    <meta
                        property="og:image"
                        content="https://www.lefuturdurap.fr/share.jpg"
                    />
                    <meta property="og:image:width" content="1200" />
                    <meta property="og:image:height" content="630" />
                    <link rel="icon" type="image/png" href="/marker.png" />
                </Helmet>
                <Global
                    styles={css`
                        ${normalizeStyles};
                        ${globalStyles};
                        ${spriteStyles};
                    `}
                />
                {this.state.isDesktop ? (
                    <Smooth>{scrollableDiv}</Smooth>
                ) : (
                    scrollableDiv
                )}

                <aside
                    css={asideClass}
                    className={classNames({
                        'is-visible': this.state.isCoverVisible,
                        'is-black': this.state.isCoverBlack,
                    })}
                    ref={this.coverRef}
                >
                    <a href={playlistLink}>
                        <p>
                            <Arrow
                                fill={
                                    this.state.isCoverBlack ? 'black' : 'white'
                                }
                            />
                            Écouter sur Deezer
                        </p>
                        <img src={cover} alt="Deezer - La Relève" />
                    </a>
                </aside>

                {!this.state.isCookieAccepted ? (
                    <div css={cookieClass}>
                        <p>
                            Ce site Web utilise des cookies. En poursuivant
                            votre navigation, vous acceptez l’utilisation par
                            Deezer et ses partenaires de cookies et autres
                            traceurs pour proposer des contenus et des offres
                            adaptés à vos centres d’intérêt, de la publicité
                            personnalisée et analyser notre trafic.
                        </p>
                        <button onClick={this.handleCookieClick}>
                            J'accepte
                        </button>
                        <a
                            href="https://www.deezer.com/legal/personal-datas"
                            target="blank"
                        >
                            En savoir plus
                        </a>
                    </div>
                ) : (
                    <Analytics />
                )}
            </>
        )
    }
}

const foregroundClass = css`
    background-image: url(${foreground});
    background-size: cover;
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    transition: opacity 0.5s linear;
    width: 100%;
    z-index: 1;

    &.is-visible {
        opacity: 0.5;
    }
`

const scrollClass = css`
    bottom: 60px;
    opacity: 0.7;
    position: absolute;
    right: 30px;
    width: 20px;

    ${mq.small(css`
        right: 120px;
    `)};
`

const cookieClass = css`
    background-color: rgba(0, 0, 0, 0.4);
    bottom: 0;
    font-size: 11px;
    left: 0;
    padding: 0.5em;
    position: fixed;
    text-align: center;
    width: 100%;
    z-index: 2;

    p {
        display: inline-block;
        margin: 0.5em 0.5em 0.5em 0;
    }

    a {
        cursor: pointer;
        text-decoration: underline;
    }

    button {
        background-color: ${WHITE};
        color: black;
        cursor: pointer;
        margin-right: 2em;
        padding: 0.8em;
    }
`

const playBtnClass = css`
    bottom: calc(25% - 4em);
    left: 50%;
    opacity: 0;
    position: absolute;
    transform: translate(-50%, 50%);
    transition: opacity 0.5s linear;
    z-index: 1;

    ${mq.small(css`
        bottom: calc(25% - 6em);
    `)};

    &.is-visible {
        opacity: 1;
    }
`

const stopBtnClass = css`
    background-position: 50% 50%;
    position: fixed;
    top: 60px;
    transform: translateX(-50%);
    left: 50%;
    z-index: 3;

    ${mq.small(css`
        left: 120px;
        transform: translateX(0);
    `)};
`

const containerClass = css`
    align-items: center;
    display: flex;
    height: 100vh;
    justify-content: center;
    left: 0;
    overflow: hidden;
    position: absolute;
    text-align: center;
    top: 0;
    transition: opacity 0.5s linear 0.5s;
    width: 100%;

    &.is-hidden {
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.5s linear;
    }
`

const dateContainerClass = css`
    position: relative;
    top: -8%;
    z-index: 2;

    ${mq.small(css`
        top: 0;
    `)};
`

const bigDateClass = css`
    font-family: 'Avenir';
    font-size: 41vh;
    font-weight: 800;
    left: 50%;
    line-height: 0.92;
    /* height: 100vh; */
    opacity: 0.5;
    /* overflow: hidden; */
    pointer-events: none;
    position: absolute;
    top: 75%;
    transform: translate3d(-50%, -50%, 0);
    user-select: none;
    /* width: 100vw; */
    z-index: -1;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke: 1px ${WHITE};

    ${mq.small(css`
        font-size: 28vw;
        /* height: auto; */
        line-height: 0;
        /* overflow: visible; */
        /* width: auto; */
    `)};

    span {
        display: block;
        opacity: 0;
        will-change: opacity;

        &:nth-of-type(1) {
            transform: translateX(-12vw);

            ${mq.small(
                css`
                    transform: translateX(0);
                `
            )};
        }

        &:nth-of-type(2) {
            transform: translateX(30vw);

            ${mq.small(
                css`
                    transform: translateX(0);
                `
            )};
        }

        ${mq.small(css`
            display: inline;
        `)};
    }
`

const titleClass = css`
    display: block;
    max-width: 1373px;
    position: relative;
    width: 86vw;

    ${mq.small(css`
        width: 72vw;
    `)};
`

const mainMaskClass = css`
    position: relative;
    user-select: none;

    &:first-of-type {
        z-index: 2;
    }
`

const containerMaskClass = css`
    display: flex;
    height: 106%;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    will-change: transform;
    z-index: 1;

    ${mq.small(css`
        height: 130%;
        top: -15%;
    `)};

    &.first {
        right: 3%;
        width: 98%;

        ${mq.small(css`
            width: 97%;
        `)};
    }

    &.two {
        right: -5%;
        width: 122%;
    }

    > img {
        height: 100%;
    }

    > div {
        background-color: black;
        width: 100%;
    }
`

const purpleClass = css`
    position: relative;

    &::before,
    &::after {
        background-size: cover;
        content: '';
        display: block;
        height: 66%;
        position: absolute;
        right: -4%;
        top: 34%;
        width: 69%;
        z-index: -1;

        ${mq.small(css`
            height: 133%;
            top: -20%;
            width: 39%;
        `)};
    }

    &::before {
        background-color: black;
        transform: skewX(-10deg);
        transform-origin: right;
        transition: transform 0.7s ${EXPO_EASE_OUT};
        width: 70%;
        z-index: 0;

        ${mq.small(css`
            width: 40%;
        `)};
    }

    &::after {
        background-image: url(${purple});
    }

    &.is-visible {
        &::before {
            transform: skewX(-10deg) scaleX(0);
        }
    }
`

const subtitleClass = css`
    bottom: -30px;
    font-family: 'Avenir';
    font-size: ${FS_M};
    font-weight: 600;
    left: 0;
    margin: 0 auto;
    position: absolute;
    right: 0;
    text-transform: uppercase;

    ${mq.small(css`
        bottom: -100px;
    `)};

    strong img {
        height: 20px;
        position: relative;
        top: 2px;
    }

    /* time {
        font-weight: 800;
    } */

    strong {
        position: relative;

        span {
            display: block;
            height: 38px;
            left: 0;
            overflow: hidden;
            position: absolute;
            top: 0;
            transform: skew(-10deg);
            transition: width 0.5s ${EXPO_EASE_OUT};
            width: 0;
            z-index: -1;
        }

        span::after {
            background-image: url(${purpleDeezer});
            content: '';
            height: 38px;
            left: -4px;
            position: absolute;
            top: 0;
            width: 100px;
            z-index: -1;

            ${mq.small(css`
                left: -7px;
                width: 111px;
            `)};
        }

        &.is-visible {
            span {
                width: 111px;
            }
        }
    }

    > * {
        display: inline-block;
        opacity: 0;
    }
`

const asideClass = css`
    bottom: 60px;
    cursor: pointer;
    display: none;
    font-size: ${FS_S};
    left: 120px;
    opacity: 0;
    position: fixed;
    text-align: center;
    transition: opacity 0.2s linear, color 0.2s linear;
    z-index: 3;

    ${mq.medium(css`
        display: block;
    `)};

    p {
        display: inline-block;
        position: relative;

        &::after {
            background-color: ${WHITE};
            bottom: 0;
            content: '';
            height: 1px;
            left: 0;
            position: absolute;
            transition: background-color 0.5s linear;
            width: 100%;
        }
    }

    img {
        display: block;
        height: 150px;
        width: 150px;

        ${mq.smallHeight(css`
            height: 170px;
            width: 170px;
        `)};
    }

    &.is-visible {
        opacity: 1;
    }

    &.is-black {
        color: black;

        img {
            box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.2);
        }

        *::after {
            background-color: black !important;
        }
    }
`

const videoClass = css`
    height: 100%;
    object-fit: cover;
    opacity: 0;
    position: absolute;
    transition: opacity 1s linear, visibility 1s linear;
    visibility: hidden;
    width: 100%;
    z-index: -1;

    &.is-visible {
        opacity: 1;
        visibility: visible;
    }
`

export const query = graphql`
    query {
        site {
            siteMetadata {
                playlistLink
            }
        }
    }
`

export default Home
